import React, { useEffect } from 'react'
import { Button, Col, Container, Form, Modal, Row, Table, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import MetricGraph from './MetricGraph';
import './Metric.css';
import Chart from "react-google-charts";
import {
    getClientsList
  } from "../eventsView/eventsViewSlice.js";
import {
    getAllMetricsByCategory,
    logMetricProgress,
    selectMetricById,
    editMetricProgress,
    deleteProgressData,
} from "../../state/metricListSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { envAwarePost } from '../../util/util';
import ReactDatePicker from 'react-datepicker';
import Select from 'react-select';
import moment from "moment";

const secondsToTime = seconds => {
    const m = Math.floor(seconds/60)
    const s = seconds - m*60
    const ss = s < 10 ? `0${s}`  : s
    return `${m}:${ss}`
}

function Metric({props}) {

    const dispatch = useDispatch();
    
    const location = useLocation()
    
    const history = useHistory()

    let clientId = new URLSearchParams(history.location.search).get('clientId')?.split('?')[0];
    const url = new URL(window.location.href);
    const trainerId = url.searchParams.get("trainer");

	const isTrainer = useSelector((state) => state.users.current_user.account_type) === "trainer"
	const hasPermission = useSelector((state) => state.users.current_user.edit_permissions?.assessment) === "1"
	const userID = useSelector((state) => state.users.current_user?.user_id_number);


    const [assessmentData, setAssessmentData] = useState([])
    const [showGraphs, setshowGraphs] = useState(true);
    const [showTables, setshowTables] = useState(false);
    const [showModal, setshowModal] = useState(false);
    const [showProgressModal, setProgressShowModal] = useState(false);
    const [showManyProgressModal, setManyProgressShowModal] = useState(false);
    const [showErrorMessage, setshowError] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("")
    const [date, setDate] = useState("");
    const [updateDate, setUpdateDate] = useState("")
    const [updateValue, setUpdateValue] = useState("")
    const [updateNotes, setUpdateNotes] = useState("")
    const [addDate, setaddDate] = useState("")
    const [bodyId, setbodyId] = useState('') // AKA metric ID
    const [addValue, setAddValue] = useState("")
    const [addNotes, setAddNotes] = useState("")
    const [newValue, setNewValue] = useState("")
    const [newNotes, setNewNotes] = useState("")
    const [statsId, setstatsID] = useState("")
    const [assessmentId, setassessmentID] = useState("")
    const [trainerData, setTrainerData] = useState([])
    const [currentClientsName, setCurrentClientsName] = useState("Client");
    const [categoryShow, setCategoryShow]=useState('All')
    const [availableMetrics, setAvailableMetrics] = useState([])
    const [selectedMetrics, setselectedMetrics] = useState([])
    const [metricEdits, setMetricEdits] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setaddDate(today)
    },[showProgressModal, setNewNotes])

    useEffect(() => {
        if(isTrainer){
            dispatch(getClientsList());
        }
      }, []);
    
    // const clientsList = {}
    const clientsList = useSelector((state) => state.users.clients.entities);
   // console.log(clientsList)
    
    useEffect(() => {
        if (Object.values(clientsList).length > 0) {
            let specifiedClient = clientsList[clientId]
            let name =specifiedClient?.user_name
            if(name){
                name = name.charAt(0).toUpperCase() + name.slice(1)
                setCurrentClientsName(name)
            }

        }
    }, [clientsList]);

    const getMetrics = () => {
        setIsLoading(true)
        let type;
		let include_progress_data=1
		let include_empty_groups=0

		if (clientId === 0){
			type = 'default'
		} else {
			type = 'client'
		}
        let client_Id=parseInt(clientId)

		const payload = {
			type,
			client_Id,
			include_progress_data,
			include_empty_groups
		}
		dispatch(getAllMetricsByCategory(payload)).then(() => {
            setIsLoading(false)
        })
    }
    const handleShowModalClose = () => {
        setshowModal(false)
    }

    const handleAddModalClose =() => {
        setProgressShowModal(false)
    }



    useEffect(() => {
        getMetrics()
	}, [])

    let metrics = (Object.values(useSelector((state) => state.metrics.entities))).sort(function(a,b){
        let textA = a.assessment_name.toUpperCase();
        let textB = b.assessment_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })
    const categories = Object.values(useSelector((state) => state.metrics.categories.entities)).sort(function(a,b){
        let textA = a.category.toUpperCase();
        let textB = b.category.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })

    // objArray.sort(function(a, b) {
    //     var textA = a.DepartmentName.toUpperCase();
    //     var textB = b.DepartmentName.toUpperCase();
    //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    // });

    //maps category array to a format for select
    const mapCategoriesToSelectObjects = array => (    
        array?.map((c,index )=> ({
                label:c.category,
                value:c.category_id,
                key:index
        }))
    )   
    const categoryOptions = [{label:'All',value:99, key:99},...mapCategoriesToSelectObjects(categories)]

    const handleCategorySelect=(e)=>{
        setCategoryShow(e.label)
    }

    const handleToggle = () => {
        if (showGraphs) {
            setshowGraphs(false)
            setshowTables(true)
        } else {
            setshowGraphs(true)
            setshowTables(false)
        }
    }

    // let selectedMetric = useSelector(state=>selectMetricById(state.metrics,bodyId))

    // checks if user has entered a valid progress entry
    const checkProgressEntry = () => {
        let isDateUsed = false;
        // let datemap = selectedMetric?.progress_data.forEach((progress) => { //ESlint errors from optional chaining
        //     if(progress.date===addDate){
        //         isDateUsed = true
        //     }
        // })
        if(bodyId===''){
            setshowError(true)
            setErrorMessage('You must pick a metric to assign progress to')
            return false
        }else if(isDateUsed){
            setshowError(true)
            setErrorMessage('That metric already has a progress entry for that date.')
            return false
        }else if(!parseInt(addValue)){
            setshowError(true)
            setErrorMessage('Value must be a number')
            return false
        }else{
            return true
        }
    }
    const handleAddProgress = () => {
        let addeditemValue = "a:1:{i:" + bodyId + ";d:" + addValue + ";}";
        if(checkProgressEntry()){
            setshowError(false)
            let payload = {
                operation: "add",
                date: addDate,
                notes: addNotes,
                metric_id:bodyId,
                value:addValue,
            }
            setProgressShowModal(false)
            dispatch(logMetricProgress(payload)).then(() => {
                getMetrics()
            })
        }
    }

    //upon clicking a progress entry to edit, this sets the placeholders as the progress's previous values
    const UpdateValues = (assessment, progress) => {
        setUpdateDate(progress.date)
        setUpdateValue(progress.value)
        setUpdateNotes(progress.notes)
        setstatsID(progress.stats_id)
        setassessmentID(parseInt(assessment.assessment_id))
        setshowModal(true)
    }

    //checks if entered value is an integer then dispatches edit metric and then gets metric list
    // if not integer, then edit value is set to previous value
    const handleUpdate = (e) => {
        let value= parseInt(updateValue)
            if(!value){
                value =updateValue
            }
            let payload={
                statsID: statsId,
                assessmentID: assessmentId,
                datepicker: updateDate,
                newValue: value,
                newNote:updateNotes 
            }
            setshowModal(false)
            dispatch(editMetricProgress(payload)).then(() => {
                getMetrics()
            })
    }

    const deleteHandler = (progress,assessment) => {
        const statID=progress.stats_id
        const assessmentID=assessment.assessment_id
		let payload = {
			statID,
            assessmentID
		}
		if (window.confirm('Are you sure you want to delete this progress entry?')) {
			dispatch(deleteProgressData(payload)).then(() => {
                getMetrics()
            })

		}
	}

    //for closing modals and hiding error message
    const handleCancel =()=>{
        setProgressShowModal(false)
        setshowError(false)
        setManyProgressShowModal(false)
        setMetricEdits({})
    }

    //checks if a metric has progress notes
    const hasNotes = (metric) => {
        let hasProgressNotes = false
        metric.progress_data.forEach(p => {
            if(p.notes!== ''){
                hasProgressNotes=true
            }
        })
        return hasProgressNotes
    }

    //upon show addManyProgress modal, finds metrics available for that date and resets selected metrics
    const showAddManyModal = () => {
        setManyProgressShowModal(true)
        filterAvailableMetrics()
        setselectedMetrics([])
    }

    const handleAddManyModalClose = () => {
        setManyProgressShowModal(false)
        setMetricEdits({})

    }

    // finds metrics that dont have a progress entry for selected date
    const filterAvailableMetrics = () => {
        let foundAvailableMetrics = []
        let hasProgressEntry;
        metrics.forEach(metric => {
            hasProgressEntry = false
            metric.progress_data.forEach(progress => {
                if(progress.date===addDate){
                    hasProgressEntry = true
                }
            })
            if(!hasProgressEntry){
                foundAvailableMetrics.push(metric)
            }
        })
        setAvailableMetrics(foundAvailableMetrics)
    }

    //upon user selecting date, finds a new list of available metrics
    const handleSetDate = (e) => {
        setaddDate(e.target.value)
        filterAvailableMetrics()
    }

    //puts metrics array into a format for select
    const mapMetricsToSelectObjects = array => (    
        array?.map((m,index )=> ({
                label:m.assessment_name,
                value:m.assessment_id,
                key:index
        }))
    )   

    //upon a metric select, adds the metric(s) into an object
    const handleSelectMetric = (e) => {
        setselectedMetrics(e)
    }
    
    // upon a metric value or note added, add the info into the metric edits object
    // this function is slow, it would be great to find another solution
    const handleManyMetricEdits = (metric, edit, type) => {
        let metricEditChanges = JSON.parse(JSON.stringify(metricEdits)) // deep copy 
        if(metricEditChanges[metric.value] === undefined){
            metricEditChanges[metric.value] = {metric, note:'',value:''}
        }
        if(type==='note'){
            metricEditChanges[metric.value].note = edit
        } else {
            metricEditChanges[metric.value].value = edit
        }
        setMetricEdits(metricEditChanges)
    }

    // maps over the metricEdits state object and dispatches an addProgress action for each, then resets metricEdits
    const handleManyEditSubmit = () => {
        let edits = Object.values(metricEdits)
        let payload;
        let addeditemValue;
        edits.forEach(edit => {
            if(edit.value !== ''){
                addeditemValue = "a:1:{i:" + edit.metric.value + ";d:" + edit.value + ";}";
                payload={
                    operation:"add",
                    date: addDate,
                    notes:edit.note,
                    metric_id:edit.metric.value,
                    value:edit.value
                }
                dispatch(logMetricProgress(payload))
            }
        })
        setManyProgressShowModal(false)
        getMetrics()
        setMetricEdits({})
    }
    
    const handleAddProgressClick= () => {
        history.push(`/addprogress?clientId=${clientId}${trainerId ? `?trainer=${trainerId}`:''}`)

    }

    const handlePrint = () => {
        window.print()
    }

    const [hasProgress, setHasProgress] = useState(false)
    useEffect(() => {
        metrics.forEach(metric => {
            if(metric?.progress_data?.length){
                setHasProgress(true)
            }
        })
    }, [metrics])

    //get todays date and format for default date
    let today = new Date();
    let dd = today.getDate();
    
    let mm = today.getMonth()+1; 
    const yyyy = today.getFullYear();
    if(dd<10) 
    {
        dd=`0${dd}`;
    } 
    
    if(mm<10) 
    {
        mm=`0${mm}`;
    }
    today = `${yyyy}-${mm}-${dd}`;

    return (
        <div className="Assessment" id="containerDiv">
            {/* <div className="assessment__trainerName" style={{height:'20px'}}>
                <p>Trainer:{trainerData && trainerData.trainerName}</p>
            </div> */}
            <div className="assessment__clientName">
                {isTrainer ? 
                                <h1 style={{lineHeight:'1.5'}}>{currentClientsName}'s Progress</h1>
                :
                <h1 style={{lineHeight:'1.5'}}>Your Progress</h1>
                }

            </div>
            <hr/>
            <div className="assessment__progressGraphsTable" style={{display: showGraphs ? 'block' : 'none'}}>
                <div className="metric__buttons">
                    <div className="assessment__link" style={{paddingTop:'10px'}}>
                        {/* <a href={`/assessmentlist/?client=${clientId}`}>Changed Listed Metrics</a> */}
                        <Button
                            variant='link'
                            // className={classes.assessmentLinkButton}
                            // style={{padding:'0px 3.6px 0px 3.6px', font:'inherit', fontSize:'inherit'}}
                            as={Link}
                            
                            to={clientId ? `/metricList/?clientId=${clientId}${trainerId ? `&trainer=${trainerId}`:''}` : `/metricList/?clientId=${userID}`}
                        >
                        {(isTrainer || hasPermission) ? 'Update Metric List' : 'Metric List'}
                        </Button>
                        <div className="assesment__buttons">
                            {(isTrainer || hasPermission) ?
                            <>
                            <Button variant="outline-success" onClick={handleAddProgressClick}>Add Progress</Button>
                            </>
                            :

                            <OverlayTrigger
                            placement={"top"}
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                    Your trainer must enable you to be able to add progress
                                </Tooltip>
                            }
                            >
                            <span>
                                <Button variant="outline-success" disabled style={{ pointerEvents: 'none' }}>Add Progress</Button> 
                            </span>
                        </OverlayTrigger>

                            }
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={
                                    <Tooltip className='print__tooltip'>
                                       To print more graphs/tables on a page, click print > more settings > pages per sheet
                                    </Tooltip>
                                }
                            >
                            <span>
                                <Button variant="outline-secondary" onClick={handlePrint} style={{float:'right', marginLeft:'10px'}}><i className="fa fa-print"></i></Button>
                            </span>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div >
                        <p style={{display:'inlineBlock', marginBottom:'5px'}}>Select a metric category:</p>
                    <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={{label:'All',value:99}}
                        name="color"
                        options={categoryOptions}
                        onChange={handleCategorySelect}
                        style={{paddingTop:'10px',display:'inlineBlock'}}
                    />
                    </div>
                    <div className="assessment__viewsButtons" style={{marginTop:'15px'}}>
                        <Button variant = {showGraphs ? 'primary': 'light'} onClick={handleToggle}>Graph Format</Button>
                        <Button variant={showTables ? 'primary' : 'light'} onClick={handleToggle}>Table Format</Button>
                    </div>
                    {isLoading ? 
                        <div style={{ display: 'flex', justify_content: 'center', alignItems:"center" }}>
                            <Spinner animation="border" role="status" variant="primary" >

                            </Spinner>
                        </div>
                    :

                        <>
                        {hasProgress ? 
                            <p style={{marginTop:'5px'}}>Note: You can zoom in by clicking & dragging on a graph. Right click to zoom back out</p>
                            : 
                            <p style={{marginTop:'5px'}}>No Progress Data yet.  Add some by clicking the "Add Progress" button above</p>
                        }
                        </>
                    }
            </div>
                    {metrics && metrics.map(assessment => (
                    <>
                        {(assessment.categorization === categoryShow || categoryShow === 'All') ?
                        assessment.progress_data?.length > 0 && 
                            <div className="assessment__progressGraphsDisplay" style={{overflowY:'visible'}}>
                
                                <div className="assessmentgraph">
                                    <h4>{assessment.assessment_name}</h4>
                                    <MetricGraph name={assessment.assessment_name} progressData = {assessment.progress_data} hasNotes={hasNotes(assessment)} assessment={assessment}/>
                                </div>
                                <div className="assessment__notes" style={{width:'auto'}}>
                                {hasNotes(assessment) ? 
                                    <Table striped bordered hover size="sm" style={{marginTop:'1em'}} className="metricProgress_table">
                                        <thead>

                                            <tr>
                                                <th>Date</th>
                                                <th>Values</th>
                                                <th>Notes</th>
                                                    {isTrainer &&
                                                    <th className='metric__deleteButton'>&#x2715;</th>
                                                }
                                            </tr>
                                            
                                        </thead>
                                        {assessment.progress_data.map(progress => (
                                            <tbody>
                                            {progress.notes !=='' ?
                                                <tr>
                                                    {(isTrainer || hasPermission) ? 
                                                        <>
                                                        {/* moment(date).format("MMM DD, YYYY"); */}
                                                            {/* <td onClick={(e) => UpdateValues(assessment, progress)} date={progress.date}>{progress.date}</td> */}
                                                            <td onClick={(e) => UpdateValues(assessment, progress)} date={progress.date}>{moment(progress.date).format("MMM DD, YYYY")}</td>
                                                            <td onClick={(e) => UpdateValues(assessment, progress)} value={progress.value}>
                                                                    {
                                                                        assessment.unit === 'time' ?
                                                                        secondsToTime(progress.value) :
                                                                        progress.value
                                                                    }
                                                                
                                                            </td>
                                                            <td onClick={(e) => UpdateValues(assessment, progress)}>{progress.notes}</td>
                                                            {isTrainer &&
                                                                <td onClick={() => deleteHandler(progress,assessment)} style={{color:'red', cursor: "pointer"}}  className='metric__deleteButton'>
                                                                    &#x2715;
                                                                </td>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            <td>{moment(progress.date).format("MMM DD, YYYY")}</td>
                                                            <td>{progress.value}</td>
                                                            <td>{progress.notes}</td>
                                                        </>
                                                    }
                                                </tr>
                                                : null}
                                            </tbody>
                                        ))
                                        }
                                    </Table>
                                    : null}
                                </div>
                            </div>
                        
                        :null}
                    </>
                ))}
            </div>
            <div className="assessment__progressGraphsTable" style={{ display: showTables ? 'block' : 'none' }}>
            <div className="metric__buttons">
            <div className="assessment__link" style={{paddingTop:'10px'}}>
                        <Button
                            variant='link'
                            // className={classes.assessmentLinkButton}
                            // style={{padding:'0px 3.6px 0px 3.6px', font:'inherit', fontSize:'inherit'}}
                            as={Link}
                            
                            to={clientId ? `/metricList/?clientId=${clientId}${trainerId ? `&trainer=${trainerId}`:''}` : `/metricList/?clientId=${userID}`}
                        >
                        Update Metric List
                        </Button>
                <div className="assesment__buttons">
                {(isTrainer || hasPermission) ?
                    <>
                    <Button variant="outline-success" onClick={handleAddProgressClick}>Add Progress</Button>
                    </>
                    :

                    <OverlayTrigger
                        placement={"top"}
                        overlay={
                            <Tooltip id={`tooltip-top`}>
                                Your trainer must enable you to be able to add progress
                            </Tooltip>
                        }
                        >
                        <span>
                            <Button variant="outline-success" disabled style={{ pointerEvents: 'none' }}>Add Progress</Button> 
                        </span>
                    </OverlayTrigger>

                    }
                    <OverlayTrigger
                        placement={"bottom"}
                        overlay={
                            <Tooltip className='print__tooltip'>
                               To print more graphs/tables on a page, click print > more settings > pages per sheet
                            </Tooltip>
                        }
                        >
                        <span >
                        <Button variant="outline-secondary" onClick={handlePrint} style={{float:'right', marginLeft:'10px'}}><i className="fa fa-print"></i></Button>
                        </span>
                    </OverlayTrigger>
                </div>
            </div>
            <div >
                <p style={{display:'inlineBlock',marginBottom:'5px'}}>Select a metric category:</p>
            <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={{label:'All',value:99}}
                name="color"
                options={categoryOptions}
                onChange={handleCategorySelect}
                style={{paddingTop:'10px',display:'inlineBlock'}}
            />
            </div>
            <div className="assessment__viewsButtons" style={{marginTop:'15px'}}>
                <Button variant = {showGraphs ? 'primary': 'light'} onClick={handleToggle}>Graph Format</Button>
                <Button variant={showTables ? 'primary' : 'light'} onClick={handleToggle}>Table Format</Button>
            </div>
            {hasProgress ? 
                        null
                        : 
                        <p style={{marginTop:'5px'}}>No Progress Data yet.  Add some by clicking the "Add Progress" button above</p>}
            </div>
                <Container>
                    <Row className='metric__tableContainer'>
                            {metrics && metrics.map(assessment => (
                            <>
                        {(assessment.categorization === categoryShow || categoryShow === 'All') ?
                            assessment.progress_data?.length > 0 && 
                                    <div className="col-xl-6 metric__tables">
                                        <h4 style={{marginTop:'1em'}}>{assessment.assessment_name}</h4>
                                        <Table striped bordered hover className="metricProgress_table">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Values</th>
                                                    <th>Notes</th>
                                                    {isTrainer &&
                                                        <th className='metric__deleteButton'>&#x2715;</th>
                                                    }
                                                </tr>
                                            </thead>
                                            {assessment.progress_data.map(progress => (
                                                <tbody>
                                                    <tr >
                                                        {(isTrainer || hasPermission) ? 
                                                            <>
                                                                <td onClick={(e) => UpdateValues(assessment, progress)} date={progress.date}>{moment(progress.date).format("MMM DD, YYYY")}</td>
                                                                <td onClick={(e) => UpdateValues(assessment, progress)} value={progress.value}>
                                                                    {
                                                                        assessment.unit === 'time' ?
                                                                        secondsToTime(progress.value) :
                                                                        progress.value
                                                                    }
                                                                </td>
                                                                <td onClick={(e) => UpdateValues(assessment, progress)}>{progress.notes}</td>
                                                                {isTrainer &&
                                                                    <td onClick={() => deleteHandler(progress,assessment)} style={{color:'red', cursor: "pointer"}}  className='metric__deleteButton'>
                                                                        &#x2715;
                                                                    </td>
                                                                }
                                                            </>
                                                            :
                                                            <>
                                                                <td>{moment(progress.date).format("MMM DD, YYYY")}</td>
                                                                <td>{
                                                                    assessment.unit === 'time' ?
                                                                    secondsToTime(progress.value) :
                                                                    progress.value
                                                                }</td>
                                                                <td>{progress.notes}</td>
                                                            </>
                                                        }
                                                    </tr>
                                                </tbody>
                                            ))}
                                        </Table>
                                    </div>
                                
                                :null}   
                            </>
                        ))}
                        {/* </Col> */}
                    </Row>
                </Container>
            </div>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showModal}
                onHide={handleShowModalClose}
            >
                <Modal.Header closeButton style={{color:'black'}}onClick={() =>setshowModal(false)}>
                    <Modal.Title id="contained-modal-title-vcenter">
                    Edit Progress Entry
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row} controlId="formHorizontalEmail">
                            <Form.Label column sm={2}>
                            Value
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control type="number" value={updateValue} onChange={(e) => setUpdateValue(e.target.value)}  />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="formHorizontalEmail">
                            <Form.Label column sm={2}>
                            Notes
                            </Form.Label>
                            <Col sm={10}>
                                <Form.Control type="text" value={updateNotes} onChange={(e) => setUpdateNotes(e.target.value)} />
                            </Col>
                        </Form.Group>
                    </Form>
                    {showErrorMessage?<p style={{color:"red"}}>{ErrorMessage}</p>:null}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={(e)=> handleUpdate(e)} variant="success">
                        Update Data</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Metric
